import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=a04d13d8&scoped=true&"
import script from "./thirdLogin.vue?vue&type=script&lang=js&"
export * from "./thirdLogin.vue?vue&type=script&lang=js&"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=a04d13d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04d13d8",
  null
  
)

export default component.exports